import * as React from "react";
const SvgXIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "100 11.43 88.57 0 50 38.57 11.43 0 0 11.43 38.57 50 0 88.57 11.43 100 50 61.43 88.57 100 100 88.57 61.43 50 100 11.43" }));
export default SvgXIcon;
